module.exports = __webpack_public_path__ + "static/media/true_new.cb72489d.svg";